export default {
    childrenStyles: {
        overflow: "visible",
        padding: "0px 40px 25px 40px",
    },
    buttonsContainer: {
        marginTop: "40px"
    },
    dropdownMenu: {
        width: "100%",
    },
    radioGroup: {
        margin: "40px 0px 0px"
    },
    radioBox: {
        display: "flex",
        margin: "20px -8px 0px",
        columnGap: "25px"
    },
    customPopupSyles: {
        minWidth: "540px"
    },
    dropdownContainer: {
        display: "flex",
        flexDirection: "column",
        rowGap: "15px"
    },
    radioLabel: {
        columnGap: "0px"
    },
    checkboxContainer: {
        paddingTop: "15px"
    }
}